import React from 'react'
import {withTranslation} from 'react-i18next'
import {Modal} from 'react-bootstrap'

const ReportModal = props => {
  return (
    <Modal
      className="expandModal audit-div"
      show={props.isInputOpen}
      onHide={() => props.closeInputModal()}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Enter New Email</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div>
          <label
            className={
              props.sendErrorMsg
                ? 'required width-100-persent report-lable required-circle'
                : 'required width-100-persent report-lable'
            }
          >
            Email Address
          </label>
          <input
            className="form-control custom-input"
            type="email"
            placeholder="Enter Your Email"
            onChange={props.feedNewEmailAdderess()}
            value={props.newUserEmail}
          />
          <div className={props.sendErrorMsg !== null ? 'text-danger mb--8' : 'display_none'}>
            {props.sendErrorMsg}
          </div>
          <button
            className="custom-send-btn1"
            onClick={() => props.sendReportInInNewEmail(props.reportType)}
          >
            Send
          </button>
          <button onClick={() => props.closeInputModal()} className="mr-1 custom-expand-cancel-btn">
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default withTranslation()(ReportModal)
